import React from "react";
import { AhJinMark } from "./AhJinLogo";
import { SeoKeywordHub } from "./SeoKeywordHub";

const Footer = () => {
  return (
    <footer className="relative bg-[#060b1e] border-t border-white/10" data-testid="site-footer">
      <div className="hairline" style={{ background: "linear-gradient(90deg, transparent, rgba(229,197,111,0.45) 30%, rgba(168,85,247,0.55) 50%, rgba(229,197,111,0.45) 70%, transparent)" }} />
      <div className="max-w-7xl mx-auto px-5 sm:px-10 py-10 sm:py-12 grid grid-cols-1 md:grid-cols-2 gap-10">
        <div>
          <AhJinMark />
          <p className="mt-5 text-zinc-500 text-sm max-w-xs leading-relaxed">
            Helping entrepreneurs move forward — from idea, to license, to go-live.
          </p>
        </div>
        <div className="md:justify-self-end">
          <div className="text-[10px] tracking-[0.4em] uppercase text-zinc-500 mb-4">Contact</div>
          <ul className="space-y-2 text-zinc-200 text-sm leading-relaxed">
            <li>
              <a href="mailto:ceo@ah-jingroup.com" className="text-zinc-300 hover:text-purple-300 transition-colors">ceo@ah-jingroup.com</a>
            </li>
            <li>
              <a href="mailto:finance@ah-jingroup.com" className="text-zinc-300 hover:text-purple-300 transition-colors">finance@ah-jingroup.com</a>
            </li>
            <li>
              <a
                href="https://wa.me/971556069046"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="text-zinc-300 hover:text-purple-300 transition-colors"
              >
                WhatsApp · +971 55 606 9046
              </a>
            </li>
          </ul>
        </div>
      </div>
      <SeoKeywordHub />
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 sm:px-10 py-6 sm:py-7" data-testid="footer-confidentiality">
          <div className="flex items-start gap-3 text-[11px] sm:text-xs text-zinc-500 leading-relaxed">
            <span className="mt-1.5 inline-block w-1.5 h-1.5 rounded-full bg-purple-400/70 shrink-0" />
            <p>
              <span className="text-zinc-200 font-medium uppercase tracking-[0.2em] text-[10px] sm:text-[11px] block mb-1.5">
                Confidentiality Notice
              </span>
              All information exchanged with Ah-Jin — including conversations, documents,
              strategies and any material shared before, during or after an engagement — is
              strictly confidential. No information may be shared, reproduced or disclosed
              to any third party without the prior written authorisation of Ah-Jin
            </p>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 sm:px-10 py-7 sm:py-8" data-testid="footer-disclaimer">
          <div className="text-[11px] sm:text-xs text-zinc-300 leading-relaxed space-y-3">
            <div className="text-zinc-100 font-medium uppercase tracking-[0.25em] text-[10px] sm:text-[11px] mb-2">
              Disclaimer & Legal Notice
            </div>
            <p>
              <span className="text-zinc-100">Ah-Jin Group</span> is operated by a free-zone
              company registered in the United Arab Emirates.
            </p>
            <p>
              Ah-Jin is a consulting and advisory firm. We assist founders and operators
              with company incorporation and licensing, corporate structuring, trading-platform
              and technology set-ups, payment-provider onboarding, banking introductions and
              broader operational launch. Our role is strictly advisory and consultative — we
              are not a regulated financial services provider, broker-dealer, custodian,
              payment institution or bank. We do not solicit deposits, hold client funds,
              offer investment advice, manage client assets or recommend any specific security,
              token, instrument or trade.
            </p>
            <p>
              <span className="text-zinc-100">Legal, compliance, AML, MLRO and related regulated work</span>{" "}
              referenced on this site is{" "}
              <span className="text-zinc-100">not performed in-house by Ah-Jin</span>.
              Ah-Jin coordinates and quality-controls — the work itself is delivered by
              independent specialists through our associates (qualified lawyers,
              AML consultants and certified MLROs), each operating under their own
              professional licence and indemnity. Ah-Jin{" "}
              <span className="text-zinc-100">does not provide training courses</span> of
              any kind; where staff training is required as part of a programme, it is
              delivered by trainers introduced through our associates.
            </p>
            <p>
              All third-party services referenced on this site — including providers of
              trading platforms, payment processing, custody, banking and customer-relationship
              management — operate under their own terms, regulatory frameworks and approval
              processes. Approval and onboarding decisions by any such institution remain at
              the sole and exclusive discretion of that institution.
            </p>
            <p>
              Information presented on this website is provided for general informational
              purposes only. It does not constitute legal, tax, regulatory, accounting,
              investment or financial advice, nor an offer or solicitation to engage in any
              transaction in any jurisdiction. Visitors should obtain independent professional
              advice before relying on any content shown here.
            </p>
            <p className="text-zinc-500">
              © {new Date().getFullYear()} Ah-Jin Group.
              All rights reserved.
            </p>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 sm:px-10 py-6 flex flex-col sm:flex-row justify-between gap-3 sm:gap-4 text-[10px] sm:text-[11px] uppercase tracking-[0.3em] sm:tracking-[0.35em] text-zinc-600">
          <div>© {new Date().getFullYear()} AH-JIN GROUP</div>
          <div>STOOD UP QUIETLY · IN THE DARK</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
